import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BastionApp } from "@bastion/game-ui";
import { gameContent } from "@bastion/data";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root mount node missing from index.html");
}

const isDebug = window.location.pathname === "/debug" || window.location.pathname === "/debug/";

createRoot(rootEl).render(
  <StrictMode>
    <BastionApp content={gameContent} mode={isDebug ? "debug" : "normal"} />
  </StrictMode>,
);
